<template>
  <!-- A rounded group of AuthRows with one line under it: an error (red)
       or a confirmation (green), never a toast. The #action slot adds a
       link after the line (e.g. "Log in" when the account exists). -->
  <div class="auth-group-wrap">
    <div class="auth-group">
      <slot />
    </div>
    <p
      v-if="message"
      class="auth-group-msg"
      :class="`is-${kind}`"
      role="status"
      aria-live="polite"
    >
      {{ message }}
      <slot name="action" />
    </p>
  </div>
</template>

<script>
export default {
  name: "AuthGroup",
  props: {
    message: { type: String, default: null },
    kind: {
      type: String,
      default: "error",
      validator: (v) => ["error", "ok"].includes(v),
    },
  },
};
</script>

<style scoped>
.auth-group {
  margin: 0 16px;
  border-radius: var(--cl-r-xl);
  background: var(--cl-cell);
  overflow: hidden;
}
.auth-group-msg {
  margin: 0;
  padding: 8px 20px 0;
  font: var(--cl-footnote);
}
.auth-group-msg.is-error {
  color: var(--cl-destructive-text);
}
.auth-group-msg.is-ok {
  color: var(--cl-live-text);
}
.auth-group-msg :deep(a) {
  color: var(--cl-accent-text);
  font-weight: 600;
  text-decoration: none;
}
</style>
